import { render } from "./VideoBottomBar.vue?vue&type=template&id=314baac6&scoped=true"
import script from "./VideoBottomBar.vue?vue&type=script&lang=js"
export * from "./VideoBottomBar.vue?vue&type=script&lang=js"

import "./VideoBottomBar.vue?vue&type=style&index=0&id=314baac6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-314baac6"]])

export default __exports__